import { Component, OnInit } from '@angular/core';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { LoadingService } from 'src/app/core/services/loading.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ProfileService } from '../../services/profile.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  searchList: Array<any> = [];
  filteredList: Array<any> = [];
  show: boolean = false;
  type: string
  questionList: Array<any> = []
  toggleItem: number = -1
  devicePlatform: string;
  constructor(private profileService: ProfileService, private loadingService: LoadingService, private storageService: StorageService) {
    this.devicePlatform = Capacitor.platform.toLowerCase();
  }

  ngOnInit() { }

  ionViewDidEnter() {
    this.loadingService.showLoading();
    this.storageService.get(StorageKeys.FILIZ_MODE).then(res => {
      if (res.IsSuccess) {
        if (res.Data) {
          this.type = 'filiz'
        } else {
          this.type = "trap"
        }
        this.getQuestions(this.type);
      }
    })
  }

  getQuestions(type: any) {
    if (type == 'filiz') {
      this.profileService.getFilizFAQQuestions().subscribe(res => {
        this.loadingService.hideLoading();
        let packageName = "com.doktar.verim365"
        this.questionList = res[packageName];
      });
    } else {
      this.profileService.getTrapFAQuestions().subscribe(res => {
        this.loadingService.hideLoading();
        this.filteredList = res;
        this.searchList = res;
        this.show = true;
      });
    }
  }
  onSearchChange(ev) {
    if (!(ev?.detail?.value == null || ev?.detail?.value == undefined)) {
      let query = ev.detail.value.toLowerCase();
      this.filteredList = this.searchList.filter(t => t.Title.toLowerCase().includes(query) || t.Description.toLowerCase().includes(query)).map(t => {
        return t;
      });
    }
    else {
      this.filteredList = this.searchList;
    }
  }
  expand(item) {
    if (this.toggleItem == item)
      this.toggleItem = -1;
    else {
      this.toggleItem = item;
    }
  }

}
